import React from 'react';
import { motion } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { t } from '../../i18n';

interface SwipeTutorialOverlayProps {
    onClose: () => void;
}

export const SwipeTutorialOverlay: React.FC<SwipeTutorialOverlayProps> = ({ onClose }) => {
    const { lang } = useLanguage();

    return (
        <div
            className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center"
            onClick={onClose}
        >
            <div className="relative w-full h-full">
                {/* Close button */}
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                    className="absolute top-4 right-4 z-10 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white md:hover:bg-white/30 transition-colors"
                >
                    <X size={16} />
                </button>

                {/* Tutorial content */}
                <div className="flex flex-col items-center justify-center h-full px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="text-center text-white"
                    >
                        <motion.div
                            animate={{
                                x: [-50, 50, -50],
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                            className="flex items-center justify-center mb-6"
                        >
                            <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-6 py-3">
                                <ChevronLeft size={24} />
                                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                                    <motion.div
                                        animate={{ rotate: [0, 15, -15, 0] }}
                                        transition={{ duration: 1, repeat: Infinity }}
                                    >
                                        👆
                                    </motion.div>
                                </div>
                                <ChevronRight size={24} />
                            </div>
                        </motion.div>

                        <motion.h2
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.6 }}
                            className="text-xl font-bold mb-2"
                        >
                            {t(lang, 'swipeGuide')}
                        </motion.h2>

                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.9 }}
                            className="text-white/80 text-sm"
                        >
                            {t(lang, 'swipeDateGuide')}
                        </motion.p>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};
